/**
 * Utility functions for Catalog module
 */

import type { CustomAttribute } from '../types'

/**
 * Decodes HTML entities in a string
 * Useful for decoding product descriptions that may contain HTML entities
 * Note: Uses textarea.innerHTML which is safe for decoding entities (no script execution)
 */
export function decodeHtml(html: string): string {
  const txt = document.createElement('textarea')
  txt.innerHTML = html
  return txt.value
}

/**
 * Finds a custom attribute value by attribute code
 */
export function findCustomAttributeValue(
  customAttributes: CustomAttribute[] | undefined,
  attributeCode: string
): string | null {
  if (!customAttributes) return null
  const attribute = customAttributes.find((attr) => attr.attribute_code === attributeCode)
  return attribute ? attribute.value : null
}
